import React from 'react';
import moment from 'moment';
import { getCurrencySymbol } from '../../../helpers/currency';
import { getTranslationKey } from '../../../modules/utils/helpers';

interface Lead {
  first_name: string;
  last_name: string;
  email: string;
  phone_no?: string;
  zipcode?: string;
}

interface Product {
  _id: string;
  title: string;
  description: string;
  price: number;
  currency: string;
}

interface Appointment {
  start: Date;
  end: Date;
}

interface ConfirmDataProps {
  lead: Lead;
  product: Product;
  appointment?: Appointment;
}

const ConfirmData: React.FC<ConfirmDataProps> = ({
  lead: { first_name, last_name, email, phone_no, zipcode },
  product,
  appointment
}) => (
  <div>
    <h2>{getTranslationKey('overview')}</h2>
    <p>
      <strong>{getTranslationKey('contactInformation')}</strong>
      <br />
      {first_name} {last_name} <br />
      {email}
      {phone_no && <div>{phone_no}</div>}
      {zipcode && <div>{zipcode}</div>}
    </p>
    {product._id && (
      <div>
        <h3 className="inline">{product.title}</h3>
        <h3 className="float-right inline">
          {product.price + getCurrencySymbol(product.currency)}
        </h3>
        <p>{product.description}</p>
      </div>
    )}
    {appointment && (
      <p>
        <strong>{getTranslationKey('appointment')}</strong>
        <br />
        {`${moment(appointment.start).format('dddd D. MMMM YYYY')} - ${moment(
          appointment.start
        ).format('HH:mm')} - ${moment(appointment.end).format('HH:mm')} Uhr`}
      </p>
    )}
  </div>
);

export default ConfirmData;
